(function(angular){
	'use strict';
	
	angular
		.module('productPage')
		.controller('oFundLandingController', [
			'APP_BASE_PATH',
			'globalConfig',
			'ReitElementFactory',
			'urlFactory',
			OFundLandingControllerFunction
		]);
	
	function OFundLandingControllerFunction(
		APP_BASE_PATH,
		globalConfig,
		ReitElementFactory,
		urlFactory
	){
		var oFundLanding = this;

		oFundLanding.submit = function() {
			var payload = {
				reitOfferingVintageId: oFundLanding.reitOfferingVintageId
			};

			urlFactory.postPromise('/add-direct-order-form-to-session.json', payload)
				.then(function(response) {
					urlFactory.redirectNewTab(APP_BASE_PATH + '/reits/checkout/start');
				});
		};

		oFundLanding.$onInit = function() {
			angular.extend(oFundLanding, globalConfig);

			ReitElementFactory
				.getReitElementsForReit(oFundLanding.oFundReitId, ['flatReitElementList'])
				.then(function(formattedLists) {
					oFundLanding.oFundElements = formattedLists.flatReitElementList;
				});
		};
	}
})(window.angular);